import React from 'react';
import { Link } from 'react-router-dom';
import { Linkedin, Github, Mail, Sparkles } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="relative bg-gray-900 text-white overflow-hidden">
      {/* Background Effects */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-primary-500 rounded-full mix-blend-multiply filter blur-3xl"></div>
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-purple-500 rounded-full mix-blend-multiply filter blur-3xl"></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center gap-2 mb-4">
              <h3 className="text-2xl font-bold">
                <span className="text-primary-400">BluePeak</span> Agency
              </h3>
              <Sparkles className="text-yellow-400 animate-sparkle" size={16} />
            </div>
            <p className="text-gray-400 mb-4 leading-relaxed">
              Building exceptional digital experiences that drive business growth.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://linkedin.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative p-3 bg-gray-800 rounded-lg text-gray-400 hover:text-primary-400 transition-all duration-300 hover:bg-gray-700 hover:scale-110"
              >
                <Linkedin size={24} />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  LinkedIn
                </span>
              </a>
              <a
                href="https://github.com"
                target="_blank"
                rel="noopener noreferrer"
                className="group relative p-3 bg-gray-800 rounded-lg text-gray-400 hover:text-primary-400 transition-all duration-300 hover:bg-gray-700 hover:scale-110"
              >
                <Github size={24} />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  GitHub
                </span>
              </a>
              <a
                href="mailto:contact@bluepeak.com"
                className="group relative p-3 bg-gray-800 rounded-lg text-gray-400 hover:text-primary-400 transition-all duration-300 hover:bg-gray-700 hover:scale-110"
              >
                <Mail size={24} />
                <span className="absolute -top-10 left-1/2 -translate-x-1/2 bg-gray-800 text-white text-xs px-2 py-1 rounded opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
                  Email
                </span>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-primary-400">Quick Links</h4>
            <ul className="space-y-2">
              {[
                { to: '/', label: 'Home' },
                { to: '/portfolio', label: 'Portfolio' },
                { to: '/services', label: 'Services' },
                { to: '/about', label: 'About' },
              ].map((link, index) => (
                <li key={link.to}>
                  <Link
                    to={link.to}
                    className="text-gray-400 hover:text-primary-400 transition-all duration-300 hover:translate-x-1 inline-block group"
                  >
                    <span className="group-hover:underline">{link.label}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-lg font-semibold mb-4 text-primary-400">Contact</h4>
            <ul className="space-y-2 text-gray-400">
              <li className="flex items-center gap-2 hover:text-primary-400 transition-colors">
                <Mail size={16} />
                <a href="mailto:contact@bluepeak.com" className="hover:underline">
                  contact@bluepeak.com
                </a>
              </li>
              <li className="hover:text-primary-400 transition-colors">
                Phone: +1 (555) 123-4567
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-8 pt-8 text-center">
          <p className="text-gray-400">
            &copy; 2024 <span className="text-primary-400">BluePeak Agency</span>. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
